import React from 'react'
import {KTIcon} from '../../../../../../_metronic/helpers'

interface Props {
  filename: string
  closeModal: () => void
}

const DetalleNivelHeader: React.FC<Props> = ({filename, closeModal}) => {
  return (
    <div className='modal-header'>
      {/* begin::Modal title */}
      <div>
        <h2 className='fw-bolder'>Detalle del Documento</h2>
        <p>{filename}</p>
      </div>
      {/* end::Modal title */}

      {/* begin::Close */}
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        onClick={() => closeModal()}
        style={{cursor: 'pointer'}}
      >
        <KTIcon iconName='cross' className='fs-1' />
      </div>
      {/* end::Close */}
    </div>
  )
}

export {DetalleNivelHeader}
